import ShareOrderItems from '@/orders/partials/ShareOrderItems';

export default {
    components: { ShareOrderItems },
    data() {
        return {
            event: null,
            showModal: false,
        };
    },
    computed: {
        scheduleDateName() {
            return _.get(this.scheduleDate, 'title');
        },
        scheduleDate() {
            return this.$store.getters['calendars/getScheduleDate']({
                calendar: 'fullCalendar',
                date: this.event.start,
            });
        },
        modalDay() {
            return this.event.start.format('dddd');
        },
        modalDate() {
            return this.event.start.date();
        },
        orderItemIds() {
            return _.reduce(
                _.get(this, 'event.data', []),
                (sum, item) => {
                    return [...sum, ...item.orderItemIds];
                },
                [],
            );
        },
        eventIsInPast() {
            return moment().isAfter(this.event.start);
        },
    },
    methods: {
        openModal(event) {
            this.event = null;
            this.$nextTick(() => {
                this.event = event;
                this.showModal = true;
            });
        },
    },
};
